import React, {FC} from 'react';
import {Input} from 'antd';

interface IPasswordInputProps {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}

export const PasswordInput: FC<IPasswordInputProps> = ({
  onKeyDown,
  onChange,
  ...props
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Блокируем ввод пробела
    if (e.key === ' ') {
      e.preventDefault();
      return;
    }
    
    // Вызываем оригинальный обработчик, если он есть
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Удаляем пробелы из значения
    const value = e.target.value.replace(/\s/g, '');
    
    // Создаем новое событие с очищенным значением
    const newEvent = {
      ...e,
      target: {
        ...e.target,
        value: value
      }
    };
    
    // Вызываем оригинальный обработчик с очищенным значением
    if (onChange) {
      onChange(newEvent);
    }
  };

  return (
    <Input.Password
      {...props}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
    />
  );
};
